module.exports = __webpack_public_path__ + "img/under-maintenance-dark.9c742f03.svg";